module.exports = __webpack_public_path__ + "img/crosshatch_thumb.5db51dd1.jpg";